module.exports = __webpack_public_path__ + "img/image-upload-black.4ea5c3a8.svg";